<template>
  <div class="flex-grow-1 account-list-container">
    <SubMenu
      class="pt-0 mt-0 pb-4 mb-4 d-flex justify-content-center account-list-container__submenu"
      :items="items"
      variant="horizontal"
    >
      <template slot-scope="{ item }">
        <router-link
          :to="{
            name: $route.name,
            params: { ...account.params, ...$route.params, tab: item.id },
          }"
        >
          <TextBlock
            :text="$t(item.key, item.labelActive || item.label, item.params)"
          />
        </router-link>
      </template>
    </SubMenu>
    <Panel v-if="currentComponent">
      <component :is="currentComponent" />
    </Panel>
    <div class="d-flex justify-content-center cta-navigation-button-wrapper">
      <router-link
        :to="{
          name: backRouteName,
          params: { ...account.params, ...$route.params },
        }"
      >
        <HeraFormBtn
          class="btn btn-secondary"
          variant="full-width"
          :label="$t('_web_tournament_back', 'Back')"
        />
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SubMenu from '@/components/common/SubMenu';
import TextBlock from '@/components/atoms/TextBlock';
import HeraFormBtn from '@/components/atoms/HeraFormBtn';
import Panel from '@/components/atoms/Panel';
import ROUTER_NAMES_ACCOUNT from '@/constants/router/account';

const Followers = () => import('../profile/Followers'); // use as profile
const Following = () => import('../profile/Following'); // use as profile

export default {
  name: 'ManageProfile',
  components: {
    SubMenu,
    TextBlock,
    Panel,
    HeraFormBtn,
  },
  computed: {
    ...mapState('current', ['account']),
    backRouteName() {
      return ROUTER_NAMES_ACCOUNT.ACCOUNT;
    },
    currentTab() {
      return this.$route.params.tab;
    },
    currentComponent() {
      return (
        this.items.filter(i => i.id === this.currentTab)[0].component || null
      );
    },
    items() {
      const { countsStrings } = this.account;

      return [
        {
          id: 'followers',
          label: 'Followers',
          labelActive: 'Followers ({followers})',
          key: '_web_profile-manage_followers-tab',
          component: Followers,
          params: countsStrings,
        },
        {
          id: 'followings',
          label: 'Followings',
          labelActive: 'Followings ({followings})',
          key: '_web_profile-manage_following-tab',
          component: Following,
          params: countsStrings,
        },
      ];
    },
  },
};
</script>

<style lang="scss">
.account-list-container__submenu {
  background-color: $new-bg-page;
}
@media (max-width: 1083px) {
  .account-list-container__submenu {
    gap: 6px;
    flex-direction: column !important;
    .list-group__item-expander {
      flex: 0 0 0px !important;
    }
    li {
      flex-grow: 1;
      min-width: unset !important;

      a {
        padding: 10px 3px !important;
        height: 100%;
      }
    }
  }
}
</style>
